import 'shared/config/sentry/instrument';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from 'app/App';
import { ErrorBoundary } from 'app/providers/ErrorBoundary';
import MUThemeProvider from 'app/providers/ThemeProvider/ui/ThemeProvider';
import QueryClientProvider from 'app/providers/api/QueryClientProvider';
import { AuthProvider } from 'app/providers/auth/AuthProvider';
import 'shared/config/i18n/i18n';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <QueryClientProvider>
    <AuthProvider>
      <Router>
        <MUThemeProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </MUThemeProvider>
      </Router>
    </AuthProvider>
  </QueryClientProvider>,
);
